module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-5e4aaf76.png";